export default __webpack_public_path__ + "static/media/620.62c1ebb8.jpg";